// extracted by mini-css-extract-plugin
module.exports = {"label":"Textarea_label__GA6Q5","label-error":"Textarea_label-error__JGb_s","textarea":"Textarea_textarea__YKqwC"};